
import Vue from 'vue';

export default Vue.extend({
  name: 'progressRating',
  props: {
    rating: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
})
